import styled from 'react-emotion';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import BaseIconButton from '@ublend-npm/aulaui-next-web/IconButton';
import Add from '@material-ui/icons/Add';
import History from '@material-ui/icons/History';
import CloudDownload from '@material-ui/icons/CloudDownload';

export const Container = styled('div')`
  height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-right: -20px;
`;

export const LineSeparator = styled('div')`
  width: calc(100% - 20px);
  height: 2px;
  min-height: 2px;
  background-color: ${colors.gray};
`;

export const Wrapper = styled('div')`
  flex: 1;
`;

export const TopRow = styled('div')`
  display: flex;
  height: ${theme.spacing.xxxxLarge};
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  margin-right: ${theme.spacing.large};
`;

export const IconsContainer = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const commonButtonProps = `
  padding: 0;
  margin-left: ${theme.spacing.xSmall};
  height: ${theme.spacing.xxxxLarge};
  width: ${theme.spacing.xxxxLarge};
  min-width: ${theme.spacing.xxxxLarge};
  line-height: 16px;
  svg {
    opacity: 1;
  }
`;

export const AddIcon = styled(Add)`
  font-size: 28px;
`;

export const AddButton = styled(BaseIconButton)`
  ${commonButtonProps}
  background-color: ${colors.designSystem.purple70};
  color: ${colors.white};

  &:hover {
    background-color: ${colors.designSystem.purple70};
    opacity: 0.86;
  }
`;

export const HistoryIcon = styled(History)`
  font-size: 28px;
`;

export const CloudDownloadIcon = styled(CloudDownload)`
  font-size: 28px;
`;

export const IconButton = styled(BaseIconButton)`
  ${commonButtonProps}
  background-color: transparent;
  color: ${colors.designSystem.blackOpacity60};

  &:hover {
    background-color: ${colors.blackAlpha(theme.opacity.alpha4)};
  }
`;

export const ParticipantsCount = styled.div`
  font-family: ${theme.font.family.workSans};
  line-height: ${theme.font.lineHeight.copy};
  font-size: ${theme.font.size.large};
  font-style: normal;
  font-weight: ${theme.font.weight.semiBold};
`;
